import { createTheme } from "@mui/material/styles";

// BidPulse brand accent. Keep in sync with --accent in index.css.
export const ACCENT = "#4F46E5";
export const BRAND = "BidPulse";

export const muiTheme = createTheme({
  palette: { primary: { main: ACCENT } },
  typography: { fontFamily: '"Open Sans", sans-serif', button: { textTransform: "none", fontWeight: 600 } },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiDataGrid: {
      styleOverrides: {
        // v7 paints header + pinned areas from this variable
        root: { border: "1px solid #E5E7EB", borderRadius: 12, backgroundColor: "#fff", "--DataGrid-containerBackground": "#F9FAFB" },
        columnHeaderTitle: { fontWeight: 600, color: "#374151" },
        row: { "&:hover": { backgroundColor: "#F5F7FF" } },
        // row actions (View/Edit/Delete) as compact soft buttons so they fit their column
        cell: {
          display: "flex",
          alignItems: "center",
          "& .MuiButton-contained": {
            minWidth: 0,
            padding: "3px 12px",
            fontSize: 13,
            boxShadow: "none",
            backgroundColor: "#EEF2FF",
            color: ACCENT,
            "&:hover": { backgroundColor: "#E0E7FF", boxShadow: "none" },
          },
          "& .MuiButton-containedError": {
            backgroundColor: "#FEF2F2",
            color: "#DC2626",
            "&:hover": { backgroundColor: "#FEE2E2" },
          },
        },
      },
    },
  },
});
